<template>
  <div class="event-container">
    <div class="event-container-outer">
      <div class="event-header">
        <p>Upcoming Events</p>
      </div>

      <div class="event-content">
        <!-- <div v-if="!eventLoad && (eventData.length != 0)" class="event-content-outer">
          <div v-for="data in eventData" :key="data" class="event-content-list"> -->
        <div v-if="!eventLoad && (eventUpcoming.length != 0)" class="event-content-outer">
          <div v-for="data in eventUpcoming" :key="data" class="event-content-list">
            <p v-html="data.activity_name" />
            <p v-html="data.department_name" />
            <p v-html="dateFormat(data.start_time, data.start_end)" />
          </div>
        </div>

        <div v-else-if="!eventLoad && (eventUpcoming.length == 0)" class="event-content-outer">
          <div class="event-null">
            <p>There are no upcoming events</p>
          </div>
        </div>

        <div v-else-if="eventLoad" class="event-content-outer">
          <div v-for="value in 5" :key="value" class="event-load" />
        </div>
      </div>

      <div @click="allEvent()" class="event-footer">
        <p>Show All Events</p>
      </div>
    </div>
  </div>

  <vue-final-modal
    v-model="modalEvent" classes="flex justify-center items-center py-10 px-4" content-class="w-full max-w-md h-auto"
    :ssr="true" :lock-scroll="true" :hide-overlay="false" :click-to-close="false" :esc-to-close="true" :prevent-click="true" :attach="false" transition="vfm" overlay-transition="vfm" :z-index-auto="true" :z-index-base="1000" :z-index="false" :focus-retain="true" :focus-trap="false"
    :fit-parent="true" :drag="false" drag-selector="" :keep-changed-style="false" :resize="false" :resize-directions="['t', 'tr', 'r', 'br', 'b', 'bl', 'l', 'tl']" :min-width="250" :min-height="250" :max-width="Infinity" :max-height="Infinity"
  >
    <div class="modal-head pt-5 pb-5">
      <h1>All Events</h1>
      <jb-button class="btn-close-modal" :icon="mdiClose" @click="allEvent()" />
    </div>

    <div class="modal-all-event">
      <div v-if="eventData.length != 0" class="all-event-container">
        <div v-for="data in eventData" :key="data" class="all-event-list">
          <p v-html="data.activity_name" />
          <p v-html="data.department_name" />
          <p v-html="dateFormat(data.start_time, data.start_end)" />
        </div>
      </div>
    </div>
  </vue-final-modal>
</template>

<script>
  /* eslint-disable */
  import { ref, reactive, onMounted, onUnmounted, watch, watchEffect, computed, nextTick } from 'vue'
  import { useToast } from 'vue-toastification'
  import { useI18n } from 'vue-i18n'
  import { AgGridVue } from 'ag-grid-vue3'
  import axios from 'axios'
  import Datepicker from "@vuepic/vue-datepicker"
  import Loading from 'vue-loading-overlay'
  import 'vue-loading-overlay/dist/vue-loading.css'
  import dayjs from 'dayjs'
  import 'dayjs/locale/id'

  import { mdiClose } from '@mdi/js'

  import Icon from "@/components/Icon"
  import JbButton from '@/components/JbButton'

  export default {
    components: {
      Icon,
      JbButton,
    },

    props: {
      eventLoad: { type: Boolean, default: false },
      eventData: { type: Array, default: () => [] },
      eventUpcoming: { type: Array, default: () => [] },
      containerHeight: { type: Number, default: 0 },
      isMobile: { type: Boolean, default: false },
      isSmall: { type: Boolean, default: false },
      isMedium: { type: Boolean, default: false },
      isLarge: { type: Boolean, default: false },
      isXl: { type: Boolean, default: false },
    },

    setup (props, { emit }) {
      dayjs.locale('id')
      const dateFormat = (date1, date2 = null) => {
        const d1 = dayjs(date1)
        const d2 = date2 ? dayjs(date2) : null

        if (!d1.isValid()) return ''

        if (!d2 || !d2.isValid()) {
          return d1.format('D MMMM YYYY')
        }

        if (d1.isSame(d2, 'day')) {
          return d1.format('D MMMM YYYY')
        }

        const sameMonth = d1.isSame(d2, 'month')
        const sameYear = d1.isSame(d2, 'year')

        if (sameMonth && sameYear) {
          return `${d1.format('D')}-${d2.format('D MMMM YYYY')}`
        }

        if (!sameMonth && sameYear) {
          return `${d1.format('D MMM')} - ${d2.format('D MMM YYYY')}`
        }

        return `${d1.format('D MMM YYYY')} - ${d2.format('D MMM YYYY')}`
      }


      const modalEvent = ref(false)
      const allEvent = () => {
        if(!modalEvent.value) {
          modalEvent.value = true
        } else {
          modalEvent.value = false
        }
      }

      return {
        mdiClose,
        dateFormat,
        modalEvent,
        allEvent
      }
    }
  }
</script>

<style lang="scss">
  .event-container {
    .event-container-outer {
      width: 100%;
      height: auto;
      box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;

      .event-header {
        width: 100%;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 16px;
        background-color: #152751;

        p {
          width: 100%;
          text-align: center;
          font-size: 16px;
          line-height: 24px;
          font-weight: 600;
          color: white;
        }
      }

      .event-content {
        width: 100%;
        height: calc(520px - 40px - 40px);
        overflow-y: auto;
        background-color: white;

        .event-content-outer {
          width: 100%;
          height: auto;
          display: flex;
          flex-direction: column;
          gap: 16px;
          padding: 8px;

          .event-content-list {
            width: 100%;
            padding: 8px;
            position: relative;
            cursor: pointer;
            transition: background-color .3s;

            &::before {
              content: '';
              width: 100%;
              height: 1px;
              background-color: lightgray;
              position: absolute;
              bottom: -7.5px;
              left: 0;
            }

            &:hover {
              background-color: whitesmoke;
            }

            p {
              width: 100%;

              &:nth-child(1) {
                font-size: 14px;
                line-height: 20px;
                font-weight: 600;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
                margin-bottom: 4px;
              }

              &:nth-child(2) {
                width: max-content;
                background-color: #152751;
                padding: 4px 12px;
                border-radius: 12px;
                font-size: 12px;
                line-height: 18px;
                font-weight: 500;
                color: white;
              }

              &:nth-child(3) {
                text-align: right;
                font-size: 12px;
                line-height: 18px;
                font-weight: 600;
              }
            }
          }

          .event-null {
            width: 100%;
            height: calc(520px - 40px - 40px - 8px - 8px);
            display: flex;
            align-items: center;

            p {
              width: 100%;
              height: auto;
              text-align: center;
              font-size: 16px;
              line-height: 24px;
              font-weight: 600;
            }
          }

          .skeleton {
            position: relative;
            overflow: hidden;
            background-color: #e3e3e3;

            &::after {
              content: "";
              position: absolute;
              inset: 0;
              transform: translateX(-100%);
              background: linear-gradient(
                90deg,
                rgba(255, 255, 255, 0) 0%,
                rgba(255, 255, 255, 0.5) 50%,
                rgba(255, 255, 255, 0) 100%
              );
              animation: shimmer 1.4s infinite;
            }
          }

          .event-load {
            @extend .skeleton;
            width: 100%;
            height: 60px;
          }

          @keyframes shimmer {
            100% {
              transform: translateX(100%);
            }
          }
        }
      }

      .event-footer {
        width: 100%;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 16px;
        background-color: white;
        cursor: pointer;

        p {
          width: 100%;
          text-align: center;
          font-size: 14px;
          line-height: 20px;
          font-weight: 600;
          color: blue;
        }
      }
    }
  }

  .modal-all-event {
    width: 100%;
    height: calc(100dvh - 120px);
    max-height: calc(100dvh - 120px);
    overflow-y: auto;
    background-color: white;
    padding: 0 16px;

    .all-event-container {
      width: 100%;
      height: auto;
      display: flex;
      flex-direction: column;
      gap: 20px;

      .all-event-list {
        width: 100%;
        padding: 8px;
        position: relative;
        cursor: pointer;
        transition: background-color .3s;

        &::before {
          content: '';
          width: 100%;
          height: 1px;
          background-color: lightgray;
          position: absolute;
          bottom: -7.5px;
          left: 0;
        }

        &:hover {
          background-color: whitesmoke;
        }

        p {
          width: 100%;

          &:nth-child(1) {
            font-size: 14px;
            line-height: 22px;
            font-weight: 600;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            margin-bottom: 8px;
          }

          &:nth-child(2) {
            width: max-content;
            background-color: #152751;
            padding: 4px 12px;
            border-radius: 12px;
            font-size: 12px;
            line-height: 18px;
            font-weight: 500;
            color: white;
          }

          &:nth-child(3) {
            text-align: right;
            font-size: 12px;
            line-height: 18px;
            font-weight: 600;
          }
        }
      }
    }
  }
</style>
